import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useApi, errMsg } from "./api";

export function useOverview(month) {
  const api = useApi();
  return useQuery({ queryKey: ["overview", month], queryFn: () => api("get", `/overview?month=${month}`) });
}

export function useDeleteShift() {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api("delete", `/shifts/${id}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["overview"] });
      toast.success("Shift deleted");
    },
    onError: (e) => toast.error(errMsg(e)),
  });
}
